<div *transloco="let t; read: 'widgets.options'" class="box-scoring-display__container">
  <xi-checkbox
    color="CX"
    [label]="t('top')"
    [value]="isTopShown"
    [checked]="isTopShown"
    [disabled]="disabled"
    (onChange)="onDisplayChanged('top', $event.detail.target.checked)"
    class="box-scoring-display__item"
  >
  </xi-checkbox>

  <xi-dropdown
    select="single"
    [data]="topBoxSet"
    [value]="topBoxSize"
    [disabled]="disabled"
    (onValueChange)="onTopBoxSizeChanged($event.detail.selected.id)"
  ></xi-dropdown>

  <xi-color-picker
    [(selectedColor)]="topColor"
    [preselectedColors]="projectPalette"
    [disabled]="disabled"
    (onColorChange)="update$.next()"
    class="box-scoring-display__item box-scoring-display__color-picker"
  ></xi-color-picker>

  <xi-checkbox
    color="CX"
    [label]="t('neutral')"
    [value]="isNeutralShown"
    [checked]="isNeutralShown"
    [disabled]="disabled"
    (onChange)="onDisplayChanged('neutral', $event.detail.target.checked)"
    class="box-scoring-display__item box-scoring-display__neutral-checkbox"
  >
  </xi-checkbox>

  <xi-color-picker
    [(selectedColor)]="neutralColor"
    [preselectedColors]="projectPalette"
    [disabled]="disabled"
    (onColorChange)="update$.next()"
    class="box-scoring-display__item box-scoring-display__color-picker"
  ></xi-color-picker>

  <xi-checkbox
    color="CX"
    [label]="t('bottom')"
    [value]="isBottomShown"
    [checked]="isBottomShown"
    [disabled]="disabled"
    (onChange)="onDisplayChanged('bottom', $event.detail.target.checked)"
    class="box-scoring-display__item"
  >
  </xi-checkbox>

  <xi-dropdown
    select="single"
    [data]="bottomBoxSet"
    [value]="bottomBoxSize"
    [disabled]="disabled"
    (onValueChange)="onBottomBoxSizeChanged($event.detail.selected.id)"
  ></xi-dropdown>

  <xi-color-picker
    [(selectedColor)]="bottomColor"
    [preselectedColors]="projectPalette"
    [disabled]="disabled"
    (onColorChange)="update$.next()"
    class="box-scoring-display__item box-scoring-display__color-picker"
  ></xi-color-picker>
</div>
